import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

/* ============================================================
   TIME-LIMITED PROMOTION — September 2026
   Auto-hides after PROMO_END. To remove permanently, delete this
   component and its usage in App.js.
   ============================================================ */
const PROMO_END = new Date("2026-09-30T23:59:59+02:00");

export const usePromoCountdown = () => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const diff = Math.max(0, PROMO_END - now);
  const active = now < PROMO_END;
  return {
    active,
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    mins: Math.floor((diff / 60000) % 60),
    secs: Math.floor((diff / 1000) % 60),
  };
};

const pad = (n) => String(n).padStart(2, "0");

const PromoBanner = () => {
  const { t } = useLanguage();
  const { active, days, hours, mins, secs } = usePromoCountdown();
  if (!active) return null;

  return (
    <div
      data-testid="promo-banner"
      className="bg-terracotta text-ink py-2 px-4 text-sm font-medium flex flex-wrap justify-center items-center gap-x-4 gap-y-1 relative z-[60]"
    >
      <span className="inline-flex items-center gap-2">
        <Sparkle size={14} aria-hidden />
        {t.promo.text}
      </span>
      <span className="font-mono text-xs opacity-90" data-testid="promo-countdown">
        {t.promo.endsIn} {days}
        {t.promo.days} {pad(hours)}
        {t.promo.hours} {pad(mins)}
        {t.promo.mins} {pad(secs)}
        {t.promo.secs}
      </span>
      <Link
        to="/pricing"
        data-testid="promo-claim-link"
        className="underline underline-offset-4 hover:opacity-80 transition-opacity font-semibold"
      >
        {t.promo.cta}
      </Link>
    </div>
  );
};

export default PromoBanner;
